module.exports = __webpack_public_path__ + "static/media/Menu_Cancel_Icon.a594ab60.svg";